import script from "./MenuSuperiorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuSuperiorComponent.vue?vue&type=script&setup=true&lang=js"

import "./MenuSuperiorComponent.vue?vue&type=style&index=0&id=0da7e11e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da7e11e"]])

export default __exports__